import React, { createContext, useCallback, useContext, useState } from 'react';
import Swal from 'sweetalert2';

const NotificationContext = createContext();

export const useNotification = () => {
  return useContext(NotificationContext);
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  // useCallback으로 고정 — 함수가 매 렌더링 바뀌면 SocketProvider effect가 재실행되어 소켓이 재연결됨
  const showNotification = useCallback((type, title, message) => {
    Swal.fire({
      icon: type,
      title,
      text: message,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      customClass: {
        popup: 'custom-toast',
      },
    });

    setNotifications(prev => [...prev, { type, title, message }]);
  }, []);

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};


